const e=(e,t)=>{const l={...e};for(let o in e)"object"==typeof e[o]&&(l[o]="label"===t?e[o].label:e[o].value);return l};export{e as default};
//# sourceMappingURL=valuesPreprocessor.js.map
